import { config, msg } from 'api';
import { UNKNOWN_ERROR } from 'utils/errors';
import { setErrorMessage, setSuccessMessage } from 'apps/notifications/actions/notifications';
import { wa } from 'apps/analytics';
import { pageEvents, pageStatistics } from 'apps/settings/analytics';
import { filterDefaultPaymentTokens, filterOtherPaymentTokens } from 'apps/settings/utils/storedPaymentDetails';
import { getPaymentDetails, setPaymentMethodError } from 'apps/settings/actions/accountDetails/storedPaymentDetails';
import { MPGS_BETA_FEATURE } from 'apps/payments/constants';

export const LINK_USAGE_STATUS_PENDING = 'PENDING';
export const LINK_USAGE_STATUS_ERROR = 'ERROR';
export const LINK_USAGE_STATUS_SUCCESS = 'SUCCESS';
export const LINK_USAGE_STATUS_CONFIRM = 'CONFIRM';
export const LINK_USAGE_STATUS_REDIRECT = 'REDIRECT';

export const LINK_USAGE_INIT = 'LINK_USAGE_INIT';
export const LINK_USAGE_INIT_ERROR = 'LINK_USAGE_INIT_ERROR';
export const LINK_USAGE_INIT_REDIRECT = 'LINK_USAGE_INIT_REDIRECT';

export const LINK_USAGE_REINIT_PAYMENT = 'LINK_USAGE_REINIT_PAYMENT';
export const LINK_USAGE_FINISH_PAYMENT = 'LINK_USAGE_FINISH_PAYMENT';

export const LINK_USAGE_SET_INITIAL_STATE = 'LINK_USAGE_SET_INITIAL_STATE';

export function receiveInitLinkUsage(data) {
  return {
    type: LINK_USAGE_INIT,
    data,
  };
}

export function receiveInitLinkUsageError({ error }) {
  return {
    type: LINK_USAGE_INIT_ERROR,
    error,
  };
}

export function receiveInitLinkUsageRedirect(data) {
  return {
    type: LINK_USAGE_INIT_REDIRECT,
    data,
  };
}

export function initLinkUsage(paymentTokenId, usage) {
  return (dispatch, getState, { network }) => {
    const isMPGS = getState().user.betaFeatures.includes(MPGS_BETA_FEATURE);
    return network.post(`${config.apiBasePath}/settings/payment-details/${paymentTokenId}/usages-init`, {
      body: JSON.stringify({ usage }),
    })
      .then((data) => {
        if (isMPGS) {
          dispatch(receiveInitLinkUsageRedirect(data));
        } else {
          dispatch(receiveInitLinkUsage(data));
        }
      })
      .catch(errorResponse => {
        if (errorResponse.data && errorResponse.data.code === 'PAYMENT_TOKEN_WITH_NOT_VALIDATED_ADDRESS') {
          return dispatch(setPaymentMethodError(errorResponse.data.code));
        }
        return dispatch(receiveInitLinkUsageError(errorResponse.data || UNKNOWN_ERROR));
      });
  };
}

export function reinitLinkUsagePayment() {
  return {
    type: LINK_USAGE_REINIT_PAYMENT,
  };
}

export function setLinkUsageInitialState() {
  return {
    type: LINK_USAGE_SET_INITIAL_STATE,
  };
}

export function finishLinkUsagePayment({ paymentStatus }) {
  return {
    type: LINK_USAGE_FINISH_PAYMENT,
    paymentStatus,
  };
}

export function finishLinkUsage(paymentTokenId, usage) {
  return (dispatch, getState, { network }) =>
    network.put(`${config.apiBasePath}/settings/payment-details/${paymentTokenId}/usages`, {
      body: JSON.stringify({ usage }),
    })
      .then(() => {
        dispatch(setSuccessMessage('Payment usages updated.'));
        return dispatch(getPaymentDetails()).then(
          response => {
            wa.triggerPageEventWithDescription(
              pageEvents.STORED_PAYMENT_DETAILS_SUCCESS_NOTIFICATION_DISPLAYED_AFTER_USAGE_ADDITION, {
                [pageStatistics.NUMBER_OF_USED_PAYMENT_TOKENS]: filterDefaultPaymentTokens(response.paymentTokens)
                  .length,
                [pageStatistics.NUMBER_OF_NOT_USED_PAYMENT_TOKENS]: filterOtherPaymentTokens(response.paymentTokens)
                  .length,
              });
          }
        );
      })
      .catch((errorResponse) => {
        wa.triggerPageEventWithDescription(
          pageEvents.STORED_PAYMENT_DETAILS_ERROR_NOTIFICATION_DISPLAYED_AFTER_USAGE_ADDITION
        );
        if (errorResponse.data && errorResponse.data.code) {
          return dispatch(setPaymentMethodError(errorResponse.data.code));
        }
        return dispatch(setErrorMessage(msg.settings.flashMessage.failure));
      });
}
